module.exports = __webpack_public_path__ + "img/DAVID_CANNON_25-rs.9059b66f.jpg";